import type { App } from 'vue'
import { inject } from 'vue'

export interface RegistryPlugin {
    useNextId: () => number
}

const key = 'app.plugin.registry'
export function installRegistryPlugin(app: App): void {
    let currentId = 1

    const plugin: RegistryPlugin = {
        useNextId: () => currentId++,
    }

    app.provide(key, plugin)
}

export function useRegistryPlugin(): RegistryPlugin {
    return inject(key) as RegistryPlugin
}

export function useNextId(): number {
    return useRegistryPlugin().useNextId()
}
